import { useCallback, useEffect, useRef } from 'react';

// Runs an action that outlives the render that started it — a timer, an
// observer, a subscription — and keeps only one of them in flight. The action
// hands back the way to call itself off; starting another calls off the one
// before it, and unmounting calls off the last.
const useCancelableAction = () => {
  const cancel = useRef<() => void>();

  useEffect(() => () => cancel.current?.(), []);

  return useCallback((action: () => () => void) => {
    cancel.current?.();
    cancel.current = action();
  }, []);
};

export default useCancelableAction;
